import { render } from "./ev3Result.vue?vue&type=template&id=a8a5dbd4&scoped=true"
import script from "./ev3Result.vue?vue&type=script&lang=js"
export * from "./ev3Result.vue?vue&type=script&lang=js"

import "./ev3Result.vue?vue&type=style&index=0&id=a8a5dbd4&scoped=true&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8a5dbd4"]])

export default __exports__